import { ReactNode } from 'react'

import { Translation } from 'react-i18next'

import { UNDEFINED_VALUE } from 'const/formatting'
import { CellRenderProps } from 'types'

const TRUTHY_FLAGS: unknown[] = [1, true, '1', 'true']
const FALSY_FLAGS: unknown[] = [0, false, '0', 'false']

const normaliseFlag = (value: unknown): unknown =>
    typeof value === 'string' ? value.trim().toLowerCase() : value

export function YesNoRenderer<RecordType>({
    value,
    undefinedValue = UNDEFINED_VALUE,
}: CellRenderProps<RecordType>): ReactNode {
    const flag = normaliseFlag(value)

    if (TRUTHY_FLAGS.includes(flag)) {
        return <Translation>{(t) => t('common:yes', 'Yes')}</Translation>
    }
    if (FALSY_FLAGS.includes(flag)) {
        return <Translation>{(t) => t('common:no', 'No')}</Translation>
    }
    return <span>{undefinedValue}</span>
}
